import Layout from "../components/Layout";

function Home() {
  return (
    <Layout>
    </Layout>
  );
}

export default Home;
